import { createContext, useContext } from "react";

export const WaitlistContext = createContext({ ready: {}, open: () => {} });
export const useWaitlist = () => useContext(WaitlistContext);

const CONTACT = "fea_contact";
export const getContact = () => {
  try {
    return JSON.parse(sessionStorage.getItem(CONTACT)) || {};
  } catch {
    return {};
  }
};
export const saveContact = (c) => sessionStorage.setItem(CONTACT, JSON.stringify(c));
